import { render, staticRenderFns } from "./GetLinkDialog.vue?vue&type=template&id=13e6bce0&scoped=true&"
import script from "./GetLinkDialog.vue?vue&type=script&lang=js&"
export * from "./GetLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6bce0",
  null
  
)

export default component.exports